
import React from "react";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";

interface BlogHeaderProps {
  onCreatePost: () => void;
}

const BlogHeader: React.FC<BlogHeaderProps> = ({ onCreatePost }) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow mb-6">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">Gerenciar Posts</h1>
          <p className="text-gray-600">Crie, edite e gerencie todos os posts do blog</p>
        </div>
        <Button 
          className="bg-toctoc-blue hover:bg-blue-700"
          onClick={onCreatePost}
        >
          <Plus className="w-4 h-4 mr-2" />
          Novo Post
        </Button>
      </div>
    </div>
  );
};

export default BlogHeader;
